module.exports = __webpack_public_path__ + "img/Rectangle 35.1fc9274f.png";